// import { useState } from "react";

// const NtslInterface = () => {
//   const [modalOpen, setModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     caseNumber: "",
//     invoiceNumber: "",
//     accessLevel: "",
//     foreignSellerId: "",
//     foreignSeller: "",
//     foreignSellerPhone: "",
//     beneficiaryCountry: "",
//     issueDate: "",
//     expiryDate: "",
//     registrant: "",
//     caseTag: "",
//     businessId: "",
//     contractType: "",
//     entryBorder: "",
//     transportMethod: "",
//     originCountries: "",
//     loadingPlace: "",
//     specialZone: "",
//     fleet: "",
//     multipleTransport: "",
//     directTransport: "",
//     totalAmount: "",
//     currencyType: "",
//     bankOperationType: "",
//     currencySupply: "",
//     otherCosts: "",
//     discount: "",
//     transportCost: "",
//     paymentType: "",
//     bank: "",
//     branch: "",
//     exportSurplus: "",
//     orderNumber: "",
//     orderIssueDate: "",
//     orderExpiryDate: "",
//     goodsGroup: "",
//     importType: "",
//     orderStatus: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = () => {
//     console.log("Submitted Data:", formData);
//     alert("اطلاعات ثبت شد!");
//     setModalOpen(false);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 flex flex-col items-center p-8 text-right">
//       <h1 className="text-3xl font-bold text-gray-800 mb-10">داشبورد Ntsl</h1>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-5xl">
//         {/* باکس غیرفعال */}
//         <div className="bg-gray-200 p-6 rounded-2xl shadow-md cursor-not-allowed opacity-50">
//           <h2 className="text-xl font-semibold text-gray-500 mb-4">
//             📈 افزایش سهمیه
//           </h2>
//           <p className="text-gray-400 mb-6">این بخش فعلاً غیرفعال است.</p>
//           <button
//             disabled
//             className="px-4 py-2 bg-gray-400 text-white rounded-xl cursor-not-allowed"
//           >
//             ورود
//           </button>
//         </div>

//         {/* باکس فعال */}
//         <div
//           className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition cursor-pointer"
//           onClick={() => setModalOpen(true)}
//         >
//           <h2 className="text-xl font-semibold text-gray-700 mb-4">
//             🗂️ رفع بازگردانی پرونده‌ها
//           </h2>
//           <p className="text-gray-500 mb-6">
//             پیگیری و رفع مشکلات مربوط به بازگردانی پرونده‌ها.
//           </p>
//           <button className="px-4 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition">
//             تکمیل
//           </button>
//         </div>
//       </div>

//       {/* مودال فرم */}
//       {modalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-10 z-50 overflow-auto">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl p-6 text-right relative">
//             {/* دکمه بستن مودال */}
//             <button
//               className="absolute top-4 left-4 px-3 py-1 bg-red-500 text-white rounded-xl hover:bg-red-600 transition"
//               onClick={() => setModalOpen(false)}
//             >
//               ✕ بستن
//             </button>

//             <h2 className="text-2xl font-bold mb-4">اطلاعات پرونده</h2>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[80vh] overflow-y-auto">
//               {Object.entries(formData).map(([key, value]) => (
//                 <div key={key} className="flex flex-col">
//                   <label className="text-gray-700 font-medium mb-1">
//                     {key}
//                   </label>
//                   <input
//                     type="text"
//                     name={key}
//                     value={value}
//                     onChange={handleChange}
//                     className="border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
//                   />
//                 </div>
//               ))}
//             </div>

//             <div className="flex justify-end gap-4 mt-6">
//               <button
//                 className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition"
//                 onClick={handleSubmit}
//               >
//                 تایید
//               </button>
//               <button
//                 className="px-4 py-2 bg-yellow-500 text-white rounded-xl hover:bg-yellow-600 transition"
//                 onClick={() => alert("ویرایش فعال شد!")}
//               >
//                 ویرایش
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default NtslInterface;

import { useState } from "react";
import toast from "react-hot-toast";
import { FaGlobe } from "react-icons/fa";

const NtslInterface = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [domainModalOpen, setDomainModalOpen] = useState(false);
  const [vpnStatus, setVpnStatus] = useState({});
  const [formVpnStatus, setFormVpnStatus] = useState(null);

  const [formData, setFormData] = useState({
    caseNumber: "",
    invoiceNumber: "",
    accessLevel: "",
    foreignSellerId: "",
    foreignSeller: "",
    foreignSellerPhone: "",
    beneficiaryCountry: "",
    issueDate: "",
    expiryDate: "",
    registrant: "",
    caseTag: "",
    businessId: "",
    contractType: "",
    entryBorder: "",
    transportMethod: "",
    originCountries: "",
    loadingPlace: "",
    specialZone: "",
    fleet: "",
    multipleTransport: "",
    directTransport: "",
    totalAmount: "",
    currencyType: "",
    bankOperationType: "",
    currencySupply: "",
    otherCosts: "",
    discount: "",
    transportCost: "",
    paymentType: "",
    bank: "",
    branch: "",
    exportSurplus: "",
    orderNumber: "",
    orderIssueDate: "",
    orderExpiryDate: "",
    goodsGroup: "",
    importType: "",
    orderStatus: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    console.log("Submitted Data:", formData);
    toast.success("اطلاعات ثبت شد");
    setModalOpen(false);
  };

  // هندل اتصال VPN
  const handleVpnConnect = (domain) => {
    setVpnStatus((prev) => ({ ...prev, [domain]: "loading" }));
    setTimeout(() => {
      setVpnStatus((prev) => ({ ...prev, [domain]: "error" }));
    }, 2000);
  };

  // هندل اتصال VPN برای فرم بازگردانی
  const handleFormVpnConnect = () => {
    setFormVpnStatus("loading");
    setTimeout(() => {
      setFormVpnStatus("error");
    }, 2000);
  };

  // دامنه‌ها
  const domains = [
    "accounts.iran.ir",
    "accounts.my.gov.ir",
    "admin.my.gov.ir",
    "admin.sso.gov.ir",
    "api.gov.ir",
    "archive.gov.ir",
    "auth.gov.ir",
    "backup.gov.ir",
    "cdn.gov.ir",
    "dev.my.gov.ir",
    "dev.sso.gov.ir",
    "dns.gov.ir",
    "edu.sso.gov.ir",
    "employee.sso.gov.ir",
    "en.iran.ir",
    "fa.iran.ir",
    "file.my.gov.ir",
    "finance.my.gov.ir",
    "finance.sso.gov.ir",
    "gallery.iran.ir",
    "gov.ir",
    "health.sso.gov.ir",
    "hr.my.gov.ir",
    "hr.sso.gov.ir",
    "id.iran.ir",
    "internal.sso.gov.ir",
    "inso.gov.ir",
    "intranet.gov.ir",
    "iran.ir",
    "is.inso.gov.ir",
    "it.my.gov.ir",
    "it.sso.gov.ir",
    "kb.iran.ir",
    "leader.ir",
    "login.iran.ir",
    "login.my.gov.ir",
    "mail.inso.gov.ir",
    "mail.iran.ir",
    "mail.my.gov.ir",
    "majlis.ir",
    "map.inso.gov.ir",
    "map.iran.ir",
    "mis.iran.ir",
    "moi.gov.ir",
    "mymail.iran.ir",
    "my.gov.ir",
    "my.inso.gov.ir",
    "mx1.inso.gov.ir",
    "mx2.gov.ir",
    "news.iran.ir",
    "ns1.iran.ir",
    "ns2.iran.ir",
    "ntsw.ir",
    "oldmail.iran.ir",
    "ostan.fars.gov.ir",
    "ostan.khorasan.gov.ir",
    "ostan.tehran.gov.ir",
    "pay.inso.gov.ir",
    "payment.inso.gov.ir",
    "pop3.iran.ir",
    "portal.inso.gov.ir",
    "portal.sso.gov.ir",
    "president.ir",
    "proxy.gov.ir",
    "secure.sso.gov.ir",
    "shenasnameh.ir",
    "sms.iran.ir",
    "social.sso.gov.ir",
    "smtp.iran.ir",
    "sso.gov.ir",
    "sso.inso.gov.ir",
    "sso.iran.ir",
    "sso.my.gov.ir",
    "stage.inso.gov.ir",
    "stage.my.gov.ir",
    "stage.sso.gov.ir",
    "staff.my.gov.ir",
    "staff.sso.gov.ir",
    "support.my.gov.ir",
    "support.iran.ir",
    "supremeleader.ir",
    "tax.gov.ir",
    "tax.sso.gov.ir",
    "test.sso.gov.ir",
    "ticket.iran.ir",
    "vpn.inso.gov.ir",
    "vpn1.inso.gov.ir",
    "vpn2.inso.gov.ir",
    "vpn3.inso.gov.ir",
    "vpn4.inso.gov.ir",
    "weather.iran.ir",
    "webservice.iran.ir",
    "wiki.iran.ir",
    "www.inso.gov.ir",
    "www.my.gov.ir",
    "scan 2.2",
    "admin.sso.gov.ir",
    "admin.my.gov.ir",
    "internal.sso.gov.ir",
    "secure.sso.gov.ir",
    "intranet.gov.ir",
    "proxy.gov.ir",
    "finance.sso.gov.ir",
    "finance.my.gov.ir",
    "pay.inso.gov.ir",
    "payment.inso.gov.ir",
    "tax.sso.gov.ir",
    "hr.sso.gov.ir",
    "hr.my.gov.ir",
    "staff.sso.gov.ir",
    "employee.sso.gov.ir",
    "mail.inso.gov.ir",
    "mail.my.gov.ir",
    "mx1.inso.gov.ir",
    "mx2.gov.ir",
    "vpn*.inso.gov.ir",
    "president.ir",
    "supremeleader.ir",
    "majlis.ir",
    "leader.ir",
    "shenasnameh.ir",
  ];

  // اطلاعات تیم فنی (کامل)
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-8 text-right">
      <h1 className="text-3xl font-bold text-gray-800 mb-10">داشبورد Ntsl</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl">
        {/* باکس رفع بازگردانی */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">
            🗂️ رفع بازگردانی پرونده‌ها
          </h2>
          <p className="text-gray-500 mb-6 text-center">
            پیگیری و رفع مشکلات مربوط به بازگردانی پرونده‌ها.
          </p>
          <div className="text-center">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-xl min-w-full hover:bg-blue-700 transition"
              onClick={() => setModalOpen(true)}
            >
              لطفا قبل از اتصال هماهنگ شده باشد
            </button>
          </div>
        </div>

        {/* باکس دامنه‌ها */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition">
          <h2 className="text-xl font-semibold text-gray-700 mb-4 flex justify-center items-center">
            <FaGlobe className="mr-2" /> ورود به دامنه مدیران
          </h2>
          <p className="text-gray-500 mb-6 text-center">
            ورود و دسترسی به تمامی دامنه های سامانه های دولتی
          </p>
          <div className="text-center">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-xl min-w-full hover:bg-blue-700 transition"
              onClick={() => setDomainModalOpen(true)}
            >
              لطفا قبل از اتصال هماهنگ شده باشد
            </button>
          </div>
        </div>
      </div>

      {/* مودال رفع بازگردانی */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 overflow-auto">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-5xl">
            {/* Header */}
            <div className="flex justify-between items-center border-b p-4">
              <h2 className="text-2xl font-bold">رفع بازگردانی پرونده‌ها</h2>
              <button
                className="px-3 py-1 bg-red-500 text-white rounded-xl"
                onClick={() => setModalOpen(false)}
              >
                ✕ بستن
              </button>
            </div>
            {/* Content */}
            <div className="p-6 max-h-[70vh] overflow-y-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {Object.entries(formData).map(([key, value]) => (
                  <div key={key} className="flex flex-col">
                    <label className="text-gray-700 font-medium mb-1">
                      {key}
                    </label>
                    <input
                      type="text"
                      name={key}
                      value={value}
                      onChange={handleChange}
                      className="border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                    />
                  </div>
                ))}
              </div>

              {/* دکمه اتصال به VPN */}
              <div className="mt-6">
                <button
                  onClick={handleFormVpnConnect}
                  className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                >
                  {formVpnStatus === "loading"
                    ? "⏳ در حال اتصال..."
                    : formVpnStatus === "error"
                    ? "❌ خطا در اتصال"
                    : "اتصال به VPN"}
                </button>
              </div>

              {/* دکمه‌ها */}
              <div className="flex justify-end gap-4 mt-6">
                <button
                  className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition"
                  onClick={handleSubmit}
                >
                  تایید
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* مودال دامنه‌ها */}
      {domainModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 overflow-auto">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-5xl">
            <div className="flex justify-between items-center border-b p-4">
              <h2 className="text-2xl font-bold flex items-center gap-2">
                <FaGlobe /> دامنه‌های دولتی
              </h2>
              <button
                className="px-3 py-1 bg-red-500 text-white rounded-xl"
                onClick={() => setDomainModalOpen(false)}
              >
                ✕ بستن
              </button>
            </div>
            <div className="p-6 max-h-[70vh] overflow-y-auto space-y-3">
              {domains.map((domain) => (
                <div
                  key={domain}
                  className="flex justify-between items-center border-b pb-2"
                >
                  <a
                    href={`http://${domain}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 hover:underline flex items-center gap-2"
                  >
                    🌐 {domain}
                  </a>
                  <button
                    onClick={() => handleVpnConnect(domain)}
                    className="px-3 py-1 text-sm bg-gray-200 rounded-lg hover:bg-gray-300"
                  >
                    {vpnStatus[domain] === "loading"
                      ? "⏳ در حال اتصال..."
                      : vpnStatus[domain] === "error"
                      ? "❌ خطا در اتصال"
                      : "اتصال به VPN"}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NtslInterface;
